module.exports = __webpack_public_path__ + "img/horizontal_3_4_5010.83a7caf6.png";